import { MasterBillOption } from '../types/masterBill'

export const deepSearchMatch = (
  option: MasterBillOption,
  searchText: string
): boolean => {
  if (!searchText) return true

  const search = searchText.toLowerCase()

  if (option.masterBlNumber?.toLowerCase().includes(search)) return true

  if (option.containerNumber?.toLowerCase().includes(search)) return true

  if (option.houseBills) {
    for (const houseBill of option.houseBills) {
      if (houseBill.houseBlNumber?.toLowerCase().includes(search)) return true

      if (houseBill.cargoDetails) {
        for (const cargo of houseBill.cargoDetails) {
          if (cargo.cargoNumber?.toLowerCase().includes(search)) return true
        }
      }
    }
  }

  return false
}
